import { render, staticRenderFns } from "./PhotoUploadEdition.vue?vue&type=template&id=36b529f9&scoped=true&"
import script from "./PhotoUploadEdition.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b529f9",
  null
  
)

export default component.exports